import { LitElement, html } from "lit";
import { styleInputMessage } from "./index.styles.js";
import PaperPlane from "../../../assets/paper_plane.svg";

class InputMessage extends LitElement {
  static properties = {
    message: { type: String, state: true },
    submit: { type: Function },
  };

  static styles = styleInputMessage;

  constructor() {
    super();
    this.message = "";
    this.submit = async () => {};
  }

  _resetHeightInput(event){
    event.target.style.height = "auto"; // Restablece la altura para recalcular
  }

  _handleInputChange(event) {
    this.message = event.target.value;
    // Ajusta dinámicamente la altura del textarea
      event.target.style.height = "auto"; // Restablece la altura para recalcular
    const newHeight = Math.min(event.target.scrollHeight, 100); // Limita el crecimiento
    event.target.style.height = `${newHeight}px`;
    // Activa el scroll si se alcanza el máximo de altura
    event.target.style.overflowY = newHeight >= 100 ? "auto" : "hidden";
  }

  async _handleSubmit() {
    if (this.submit && typeof this.submit === "function" && this.message.trim().length > 0) {
      try {
        const messageUser = this.message;
        this.message = "";
        this.requestUpdate(); // Asegura que el textarea se reinicie visualmente
        await this.submit(messageUser);
        // Restablece el tamaño original del textarea después de enviar
        const textarea = this.shadowRoot.querySelector(".input-message");
        if (textarea) {
          textarea.style.height = "auto"; // Vuelve al tamaño inicial
          textarea.style.overflowY = "hidden"; // Oculta el scroll cuando está vacío
        }
      } catch (err) {
        console.error("Problemas al comunicarse con el chat-bot: ", err?.message);
      }
    }
  }

  _handleKeyPress(event) {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault(); // Evita el salto de línea y envía el mensaje
      this._handleSubmit();
    }
  }

  render() {
    return html`
      <div class="input-message-container">
      <div class="input-message-overlay"></div>
        <textarea
          class="input-message"
          .value=${this.message}
          @input=${this._handleInputChange}
          @keydown=${this._handleKeyPress}
          placeholder="Escribe tu mensaje..."
          rows="1"
        ></textarea>
          <button
            @click=${this._handleSubmit}
            class="button-send"
            aria-label="Enviar mensaje"
            title="Enviar mensaje"
            .disabled=${this.message.trim().length === 0}
          >
            <img class="icon-send" src=${PaperPlane} alt="Icono de enviar" />
          </button>
      
      </div>
    `;
  }
}

customElements.define("input-message-component", InputMessage);
